export const OfficeAutopilotListState = {
	url: '/autopilot',
	title: 'Office Autopilot',
	template: '<office-autopilot-page></office-autopilot-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeAutopilotListRulesPageMod" */
			'@Containers/office-autopilot-page/office-autopilot-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};

export const OfficeAutopilotCreateState = {
	title: 'Office Create Rule',
	name: 'office.autopilotCreate',
	url: '/autopilot/create/:type',
	template: '<rule-general></rule-general>',
	params: {type: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeAutopilotCreateRuleGeneralMod" */
			'@Containers/office-autopilot-page/rule-general-form/rule-general.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};

export const OfficeAutopilotUpdateState = {
	title: 'Office Edit Rule',
	name: 'office.autopilotUpdate',
	url: '/autopilot/update/:type/:id',
	template: '<rule-general></rule-general>',
	params: {id: null, type: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeAutopilotUpdateRuleGeneralMod" */
			'@Containers/office-autopilot-page/rule-general-form/rule-general.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
